import { useTranslation } from "react-i18next";

import { CreateProfileForm } from "@/features/profile/tutor/components/create-profile/CreateProfileForm.tsx";

export default function CreateProfilePage() {
  const { t } = useTranslation("profile");

  return (
    <div className={"flex h-full w-full items-center justify-center"}>
      <div
        className={
          "bg-background text-accent-foreground flex h-full w-full flex-col items-center justify-center gap-6 rounded-lg text-center 2xl:w-3/4"
        }
      >
        <title>{`${t("createProfile.title")} - Ximly`}</title>
        <CreateProfileForm />
      </div>
    </div>
  );
}
